import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;
  margin-bottom: 24px;
`;

export const Value = styled.div`
  flex: 0 0 auto;
  color: ${theme.colors.mainBlue};
  font-weight: 600;
`;
